module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/iconfont-web-and-print-511f1cd462c94d2ac822bbc72ed8684a.eot";